module.exports = __webpack_public_path__ + "static/media/star-branco.32c5e577.jpg";